export const deleteAllEntries = () => ({
    type: "DELETE_ALL_ENTRIES"
})

export const setAllEntries = (entries) => ({
    type: "SET_All_ENTRIES",
    entries
})